/**
 * Distinguishes the two ways a feature can be "in development" for the tenant:
 * - `gated`: a brand-new experience that isn't enabled yet (nothing to fall back to).
 * - `newVersion`: a new version layered on an existing, still-available experience.
 */
export type PreviewVariant = "gated" | "newVersion";

export const PREVIEW_FEATURE_TOOLTIP =
  "This feature is in development and not yet enabled for this organization.";

export const PREVIEW_NEW_VERSION_TOOLTIP =
  "A new version of this feature is in development and not yet enabled for this organization. You're seeing the current version.";

export function previewTooltipForVariant(variant: PreviewVariant): string {
  return variant === "newVersion" ? PREVIEW_NEW_VERSION_TOOLTIP : PREVIEW_FEATURE_TOOLTIP;
}

export const PREVIEW_ICON_FONT_SIZE = 20;

/** Space between nav/breadcrumb label and the in-development icon (theme spacing units). */
export const PREVIEW_ICON_GAP = 1;
